import { render } from "./SpecialConsiderations.vue?vue&type=template&id=298b954c"
import script from "./SpecialConsiderations.vue?vue&type=script&lang=js"
export * from "./SpecialConsiderations.vue?vue&type=script&lang=js"

import "./SpecialConsiderations.vue?vue&type=style&index=0&id=298b954c&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__